<template>
  <app-spinner v-if="loading > 0"></app-spinner>
  <main v-else class="page-content bg-white">
    <!-- Start Carousel 3d -->
    <div v-if="getContentSlides2">
      <carousel-3d id="carousel3d"
                   :autoplay="true"
                   :autoplayTimeout="5000"
                   :autoplayHoverPause="true"
                   :controls-visible="true"
                   :controls-prev-html="'&#10092;'"
                   :controls-next-html="'&#10093;'"
                   :controls-width="30"
                   :controls-height="60"
                   :clickable="true">
        <slide :index="index"
               class="text-white"
               :key="'slide-'+index"
               v-for="(contentSlide, index) in getContentSlides2">
          <app-content-slide :contentSlide="contentSlide" :page=1></app-content-slide>
        </slide>
      </carousel-3d>
    </div>
    <!-- End Carousel 3d -->
    <!-- Main Slider END -->
    <div id="page_content" class="content-block">
      <div class="section-full search-filter">
        <div class="container">
          <ul id="myTab" class="nav nav-pills" role="tablist">
            <li class="nav-item">
              <a id="service0-tab" aria-controls="tout" aria-selected="true" class="nav-link active" data-toggle="tab"
                 href="#service0" role="tab">Tout</a>
            </li>
            <li class="nav-item">
              <a id="service1-tab" aria-controls="hôtels" aria-selected="false" class="nav-link" data-toggle="tab"
                 href="#service1" role="tab">Hôtels</a>
            </li>
            <li class="nav-item">
              <a id="service2-tab" aria-controls="restaurants" aria-selected="false" class="nav-link" data-toggle="tab"
                 href="#service2" role="tab">Restaurants</a>
            </li>
            <li class="nav-item">
              <a id="service3-tab" aria-controls="tourisme" aria-selected="false" class="nav-link" data-toggle="tab"
                 href="#service3" role="tab">Tourisme</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="section-full search-form-bx">
        <div class="container">
          <div id="myTabContent" class="tab-content">
            <div id="service0" aria-labelledby="service0-tab" class="tab-pane fade show active" role="tabpanel">
              <form action="backend/index.php?action=search_offers" class="row sp20" method="post">
                <input class="form-control d-none" name="service_id" type="hidden" value="0">
                <div class="col-6 col-sm-4 col-lg-3 form-group">
                  <label for="search_min_amount">Prix ($)</label>
                  <input id="search_min_amount" class="form-control" name="min_amount"
                         placeholder="Indiquez votre prix" required type="number">
                </div>
                <div class="col-6 col-sm-4 col-lg-3 form-group">
                  <label>Réchercher</label>
                  <button class="site-button btn-block text-uppercase" type="submit">Réchercher</button>
                </div>
              </form>
            </div>
            <div id="service1" aria-labelledby="service1-tab" class="tab-pane fade" role="tabpanel">
              <form class="row sp20" method="post">
                <input class="form-control d-none" name="service_id" type="hidden" value="">
                <div class="col-6 col-sm-4 col-lg-3 form-group">
                  <label for="search_min_amount">Prix ($)</label>
                  <input id="search_min_amount" class="form-control" name="min_amount"
                         placeholder="Indiquez votre prix" required type="number">
                </div>
                <div class="col-6 col-sm-4 col-lg-3 form-group">
                  <label>Réchercher</label>
                  <button class="site-button btn-block text-uppercase" type="submit">Réchercher</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search Results START -->
    <div class="section-full bg-white content-inner dlab-about-1 promotions" id="about-us">
      <div class="container">
        <div class="section-head text-center">
          <h2 class="text-uppercase m-b0">Résultats (4)</h2>
          <p class="font-18">LES OFFRES CORESPONDANT &Agrave; VOS CRIT&Egrave;RES DE RECHERCHE</p>
        </div>
        <div class="row packages">
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../../assets/img/upload_images/offers/exposition.png" alt=""></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../../assets/img/upload_images/offers/exposition.png" alt=""></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../../assets/img/upload_images/offers/exposition.png" alt=""></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../../assets/img/upload_images/offers/exposition.png" alt=""></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <h5 class='w-100 text-info text-center'>Aucune offre trouvée correspond à vos critères de recherche pour le moment !</h5>-->
    <!-- Search Results END -->
    <!-- Featured Destinations -->
    <div class="section-full bg-white content-inner-2">
      <div class="container">
        <div class="section-head style1 text-black text-center">
          <h2>Trouver l'endroit idéale</h2>
          <div class="dlab-separator bg-primary"></div>
          <p>Les meilleurs offres de services hotelières, de restauration ou encore des tourisme partout en République
            démocratique du Congo.</p>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="featured-bx style2">
              <div class="featured-media">
                <img alt="" src="../../assets/img/featured/pic1.jpg">
                <div class="featured-tag">Service</div>
              </div>
              <div class="featured-content text-white">
                <div>
                  <h2 class="title"><a href="">Hôtels</a></h2>
                  <p>Trouver les meilleurs offres des services hoteliers adaptées selon vos standards.</p>
                  <a class="site-button outline white" href="">Voir les offres</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="featured-bx style2">
              <div class="featured-media">
                <img alt="" src="../../assets/img/featured/pic2.jpg">
                <div class="featured-tag">Service</div>
              </div>
              <div class="featured-content text-white">
                <div>
                  <h2 class="title"><a href="#">Restaurant</a></h2>
                  <p>Trouver les meilleurs offres des services de restauration adaptées selon vos standards.</p>
                  <a class="site-button outline white" href="#">Voir les offres</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="featured-bx style2">
              <div class="featured-media">
                <img alt="" src="../../assets/img/featured/pic3.jpg">
                <div class="featured-tag">Service</div>
              </div>
              <div class="featured-content text-white">
                <div>
                  <h2 class="title"><a href="#">Tourisme</a></h2>
                  <p>Trouver les meilleurs offres des services touristique adaptées selon vos standards.</p>
                  <a class="site-button outline white" href="#">Voir les offres</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="featured-bx style2">
              <div class="featured-media">
                <img alt="" src="../../assets/img/featured/pic4.jpg">
                <div class="featured-tag">Abonnement</div>
              </div>
              <div class="featured-content text-white">
                <div>
                  <h2 class="title"><a href="#">Souscription</a></h2>
                  <p>Souscrivez-vous pour ne ratez aucune offres du moment publiée su la platforme. et vous serez
                    notifié a chaque publication sur l'établisement choisi.</p>
                  <a class="site-button outline white" href="#">Souscrire</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12">
            <div class="featured-bx style2">
              <div class="featured-media">
                <img alt="" src="../../assets/img/featured/pic5.jpg">
                <div class="featured-tag">News</div>
              </div>
              <div class="featured-content text-white">
                <div>
                  <h2 class="title"><a href="#">Newsletter </a></h2>
                  <p>Abonnez-vous pour ne ratez aucune offres du moment et articles publiée su la platforme.</p>
                  <a class="site-button outline white" href="#">Lire</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Featured Destinations End -->
    <div class="section-full content-inner bg-img-fix overlay-black-middle"
         style="background-image: url('src/assets/img/background/bg3.jpg'); background-position: left bottom;">
      <div class="container">
        <div class="video-banner-box">
          <div>
            <a class="popup-youtube video play-btn" href="https://www.youtube.com/watch?v=Dj6CKxQue7U"><i
                class="fa fa-play"></i></a>
            <h2 class="title">Découvrir le Congo</h2>
            <h4 class="sub-title">Commencez la visite maintenant </h4>
            <a href="#">PAR ICI</a>
          </div>
        </div>
      </div>
    </div>
    <!-- Our Services -->
    <div class="section-full content-inner bg-gray">
      <div class="container">
        <div class="section-head style1 text-black text-left text-center">
          <h2>Meilleurs offres publiées</h2>
          <div class="dlab-separator bg-primary"></div>
          <p>Ne ratez aucune des meilleurs offres publiées récenment pourraient vous intéressez.</p>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="dlab-box packages-bx">
              <div class="dlab-media">
                <a href="#">
                  <img src="../../assets/img/upload_images/offers/parcs_bonobo.png" alt="image offre">
                </a>
                <span class="tag yellow">Meilleure Offre</span>
              </div>
              <div class="dlab-info">
                <div class="head-title">
                  <span class="time">LOLA YA BONOBO</span>
                  <h4 class="dlab-title">
                    <a href="#">Visite parc des bonobos</a>
                  </h4>
                  <span class="location">'.$offre["offer_enterprise"]["address"].'</span>
                </div>
                <div class="package-content">
                  <div class="review-bx">
                    <ul class="rating-star">
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                    </ul>
                    <span>(5 Review)</span>
                  </div>
                  <div class="price-bx">
                    <del class="price-del">20$</del>
                    <span class="price-main">10$ <em class="font-weight-normal font-16">(7%)</em></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="dlab-box packages-bx">
              <div class="dlab-media">
                <a href="#">
                  <img src="../../assets/img/upload_images/offers/parcs_bonobo.png" alt="image offre">
                </a>
                <span class="tag yellow">Meilleure Offre</span>
              </div>
              <div class="dlab-info">
                <div class="head-title">
                  <span class="time">LOLA YA BONOBO</span>
                  <h4 class="dlab-title">
                    <a href="#">Visite parc des bonobos</a>
                  </h4>
                  <span class="location">'.$offre["offer_enterprise"]["address"].'</span>
                </div>
                <div class="package-content">
                  <div class="review-bx">
                    <ul class="rating-star">
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                    </ul>
                    <span>(5 Review)</span>
                  </div>
                  <div class="price-bx">
                    <del class="price-del">20$</del>
                    <span class="price-main">10$ <em class="font-weight-normal font-16">(7%)</em></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Our Services -->
    <!-- Testimonials -->
    <div class="section-full bg-white content-inner-1 testimonial-one-area overlay-black-dark" style="background-image:url(images/background/bg1.jpg); background-position: left bottom;">
      <div class="container">
        <div class="section-head style1 text-center text-white">
          <h2 class="box-title">Les Avis</h2>
          <div class="dlab-separator bg-primary"></div>
          <p>Ce que les experts disent sur nous.</p>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div id="owl-demo" class="testimonial-center owl-loaded owl-btn-3 owl-theme btn-white owl-dots-none owl-carousel owl-btn-center-lr">
                <div class="item">
                  <div class="testimonial-1 style-2" style="background-image:url('src/assets/img/tour/pic1.jpg');">
                    <div class="testimonial-detail clearfix">
                      <div class="testimonial-pic radius">
                        <img src="../../assets/img/testimonials/pic1.jpg" width="100" height="100" alt="">
                      </div>
                      <strong class="testimonial-name text-primary">Pamela Landreville</strong>
                      <span class="testimonial-position">Africa Tourisme consulting</span>
                    </div>
                    <div class="testimonial-text">
                      <p>Le potentiel du secteur est assez grand dans le tourisme en RDC, Yebo est un service qui aide beaucoup.</p>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div class="testimonial-1 style-2" style="background-image:url(src/assets/img/tour/pic3.jpg);">
                    <div class="testimonial-detail clearfix">
                      <div class="testimonial-pic radius">
                        <img src="../../assets/img/testimonials/pic2.jpg" width="100" height="100" alt="">
                      </div>
                      <strong class="testimonial-name text-primary">Al Kitenge</strong>
                      <span class="testimonial-position">Expert economique</span>
                    </div>
                    <div class="testimonial-text">
                      <p>Comprendre que le congo a besoin de booster l'economie par des produits locaux en NTIC! Félicitation Yebo.</p>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div class="testimonial-1 style-2" style="background-image:url(src/assets/img/tour/pic6.jpg);">
                    <div class="testimonial-detail clearfix">
                      <div class="testimonial-pic radius">
                        <img src="../../assets/img/testimonials/pic3.jpg" width="100" height="100" alt="">
                      </div>
                      <strong class="testimonial-name text-primary">Gaylord KASAYI</strong>
                      <span class="testimonial-position">Entrepeneur</span>
                    </div>
                    <div class="testimonial-text">
                      <p>Renforcer la pénétration digital des services hoteliers, des restaurations et du tourisme en RDC.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Testimonials End -->
    <!-- Featured Destinations -->
    <div class="section-full bg-white content-inner-2">
      <div class="container">
        <div class="section-head style1 text-black text-center">
          <h2 class="box-title">Notre Blog</h2>
          <div class="dlab-separator bg-primary"></div>
          <p>Les articles intéressantes sont publiés hebdommadairement enfin de vous informez.</p>
        </div>
        <div class="blog-carousel owl-carousel owl-btn-center-lr owl-btn-2 primary">
          <div class="item">
            <div class="blog-post blog-grid blog-style-1 blog-shadow">
              <div class="dlab-post-media dlab-img-effect radius-sm"> <a href="#"><img src="../../assets/img/blog/grid/pic1.jpg" alt=""></a> </div>
              <div class="dlab-info">
                <div class="dlab-post-meta">
                  <ul class="d-flex align-items-center">
                    <li class="post-date">September 18, 2020</li>
                    <li class="post-comment"><a href="#">5k</a> </li>
                  </ul>
                </div>
                <div class="dlab-post-title ">
                  <h5 class="post-title font-20"><router-link to="details-article">WADA to investigate fresh Russian Olympic doping claims</router-link></h5>
                </div>
                <div class="dlab-post-readmore blog-share">
                  <router-link to="details-article" title="READ MORE" rel="bookmark" class="site-button-link border-link black">READ MORE</router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="blog-post blog-grid blog-style-1 blog-shadow">
              <div class="dlab-post-media dlab-img-effect radius-sm"> <a href="#"><img src="../../assets/img/blog/grid/pic2.jpg" alt=""></a> </div>
              <div class="dlab-info">
                <div class="dlab-post-meta">
                  <ul class="d-flex align-items-center">
                    <li class="post-date">September 18, 2020</li>
                    <li class="post-comment"><a href="#">5k</a> </li>
                  </ul>
                </div>
                <div class="dlab-post-title ">
                  <h5 class="post-title font-20"><router-link to="details-article">WADA to investigate fresh Russian Olympic doping claims</router-link></h5>
                </div>
                <div class="dlab-post-readmore blog-share">
                  <router-link to="details-article" title="READ MORE" rel="bookmark" class="site-button-link border-link black">READ MORE</router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="blog-post blog-grid blog-style-1 blog-shadow">
              <div class="dlab-post-media dlab-img-effect radius-sm"> <a href="#"><img src="../../assets/img/blog/grid/pic3.jpg" alt=""></a> </div>
              <div class="dlab-info">
                <div class="dlab-post-meta">
                  <ul class="d-flex align-items-center">
                    <li class="post-date">September 18, 2020</li>
                    <li class="post-comment"><a href="#">5k</a> </li>
                  </ul>
                </div>
                <div class="dlab-post-title ">
                  <h5 class="post-title font-20"><router-link to="details-article">WADA to investigate fresh Russian Olympic doping claims</router-link></h5>
                </div>
                <div class="dlab-post-readmore blog-share">
                  <router-link to="details-article" title="READ MORE" rel="bookmark" class="site-button-link border-link black">READ MORE</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Featured Destinations End -->
  </main>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'
import ContentSlide from '../shared/ContentSlide'

export default {
  name: "index",
  props: {},
  data() {
    return {
      loading: 0,
    }
  },
  components: {
    AppContentSlide : ContentSlide
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([
        "getContentSlides2"
    ]),
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
.animate__animated {
  --animate-duration: 1s;
  --animate-delay: 2s;
}
.search-filter .nav{
  margin-top: -1.5rem;
}
main {
}

@media (min-width: 576px) {
  main {
  }
}

@media (min-width: 768px) {
  main {
  }
}

@media (min-width: 992px) {
  main {
  }
}

@media (min-width: 1200px) {
  main {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/accueil/index.vue